import { render } from "./Historico.vue?vue&type=template&id=f7031878"
import script from "./Historico.vue?vue&type=script&lang=ts"
export * from "./Historico.vue?vue&type=script&lang=ts"
script.render = render

export default script